const DEVICE_OPTIONS = [
   {
      value: 0,
      label: 'All',
      name: 'All',
      id: 0,
   },
   {
      value: 1,
      label: 'Desktop',
      name: 'Desktop',
      id: 1,
   },
   {
      value: 2,
      label: 'Mobile',
      name: 'Mobile',
      id: 2,
   },
];

export default DEVICE_OPTIONS;
